<template>
<div>
    <CModal
        size="lg"
        :centered="true"
        color="white"
        :show.sync="modalDetail"
        :closeOnBackdrop="false"
        >
        <template #header-wrapper>
            <div class="headers-modal">
                <CRow>
                    <CCol sm="10">
                        <div>Detail Izin Cuti Dan Lainnya</div>
                    </CCol>
                    <CCol sm="2" class="text-right">
                        <img :src="closeIcon" @click="modalDetail = false" style="cursor:pointer" width="20px" height="20px"/>
                    </CCol>
                </CRow>
            </div>
        </template>
        <template #body-wrapper>
            <div style="padding-bottom:40px;padding-right:20px;padding-left:20px">
                <CRow class="mt-3">
                    <CCol sm="3">
                        <span>Nama Pegawai</span>
                    </CCol>
                    <CCol sm="9">
                        : <span class="font-weight-bold">{{details.nama}}</span>
                    </CCol>
                </CRow>
                <CRow class="mt-2">
                    <CCol sm="3">
                        <span>NIP</span>
                    </CCol>
                    <CCol sm="9">
                        : {{details.nik}}
                    </CCol>
                </CRow>
                <CRow class="mt-2">
                    <CCol sm="3">
                        <span>Nama Atasan</span>
                    </CCol>
                    <CCol sm="9">
                        : {{details.namaAtasan}}
                    </CCol>
                </CRow>
                <CRow class="mt-2">
                    <CCol sm="3">
                        <span>Agenda</span>
                    </CCol>
                    <CCol sm="9">
                        : <span class="font-weight-bold">{{details.keterangan}}</span>
                    </CCol>
                </CRow>
                <CRow class="mt-2">
                    <CCol sm="3">
                        <span>Tanggal Mulai</span>
                    </CCol>
                    <CCol sm="9">
                        : {{details.tanggalMulai}}
                    </CCol>
                </CRow>
                <CRow class="mt-2">
                    <CCol sm="3">
                        <span>Tanggal Selesai</span>
                    </CCol>
                    <CCol sm="9">
                        : {{details.tanggalSelesai}}
                    </CCol>
                </CRow>
                <CRow class="mt-2">
                    <CCol sm="3">
                        <span>Lama (Hari)</span>
                    </CCol>
                    <CCol sm="9">
                        : {{details.lamaCuti}}
                    </CCol>
                </CRow>
                <CRow class="mt-2">
                    <CCol sm="3">
                        <span>Keterangan Pengajuan</span>
                    </CCol>
                    <CCol sm="9">
                        : {{details.keteranganTidakMasuk}}
                    </CCol>
                </CRow>
                <CRow class="mt-2">
                    <CCol sm="3">
                        <span>Keterangan Persetujuan</span>
                    </CCol>
                    <CCol sm="9">
                        : {{details.keteranganApprove}}
                    </CCol>
                </CRow>
                <CRow class="mt-2">
                    <CCol sm="3">
                        <span>Status</span>
                    </CCol>
                    <CCol sm="9">
                        <div v-if="details.status == 'A' || details.status == 'a'" class="statusDisetujui status" style="float:left!important">
                            <span>Disetujui</span>
                        </div>
                        <div v-if="details.status == 'R' || details.status == 'r'" class="statusDitolak status" style="float:left!important">
                            <span>Ditolak</span>
                        </div>
                        <div v-if="details.status == 'W' || details.status == 'w'" class="statusBaru status" style="float:left!important">
                            <span>Waiting</span>
                        </div>
                    </CCol>
                </CRow>
                <CRow class="mt-5">
                    <CCol sm="8"></CCol>
                    <CCol sm="4">
                        <CButton style="width:100%!important" @click="modalDetail = false" class="btn-cancel">Kembali</CButton>
                    </CCol>
                </CRow>
            </div>
        </template>
        <template #footer-wrapper><span></span></template>
    </CModal>
    <div class="dekstop-view">
        <div class="tableFixHead sticky2">
            <table>
                <thead>
                    <tr>
                        <th @click="clickThead(index)" style="cursor:pointer" v-for="(item, index) in th" :key="index" :style="loadStyle(index)">
                            <span v-if="item != 'Action'" style="float:left">{{item}}</span>
                            <span v-if="item == 'Action'" style="float:right">{{item}}</span>
                            <img v-if="item != 'Action'" :src="sortIcon[index]" width="16px" height="16px" style="float:right"/>
                        </th>
                    </tr>
                </thead>
            </table>
        </div>
        <div class="content-sticky">
            <CRow>
                <CCol sm="12">
                    <div class="tableFixHead">
                        <table>
                            <tbody v-if="data.length == 0">
                                <tr>
                                    <td class="text-center" colspan="7">
                                        {{errors}}
                                    </td>
                                </tr>
                            </tbody>
                            <tbody v-else>
                                <tr @click="showDetail(id)" style="cursor:pointer" title="Lihat Detail" v-for="(body, id) in data" :key="id">
                                    <td v-for="(item, index) in td" :key="index" :style="loadStyle(index)">
                                        <template v-if="item == 'tanggalMulai' || item == 'tanggalSelesai'">
                                            {{separatorDate(body[item])}}
                                        </template>
                                        <template v-else>
                                            <template v-if="item == 'status'">
                                                <template v-if="body[item] == '' || body[item] == 'null' || body[item] == null || body[item] == undefined || body[item] == 'W'">
                                                    <div class="statusBaru status">
                                                        <span>Waiting</span>
                                                    </div>
                                                </template>
                                                <template v-if="body[item] == 'A' || body[item] == 'a'">
                                                    <div class="statusDisetujui status">
                                                        <span>Disetujui</span>
                                                    </div>
                                                </template>
                                                <template v-if="body[item] == 'R' || body[item] == 'r'">
                                                    <div class="statusDitolak status">
                                                        <span>Ditolak</span>
                                                    </div>
                                                </template>
                                            </template>
                                            <template v-else>
                                                <template v-if="item == 'lamaCuti'">
                                                    <span>{{body[item]}} Hari</span>
                                                </template>
                                                <template v-else>
                                                    <span :title="body[item]">
                                                        {{body[item]}}
                                                    </span>
                                                </template>
                                            </template>
                                        </template>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </CCol>
            </CRow>
        </div>
    </div>
    <div class="mobile-view">
        <CRow class="mt-3">
            <CCol sm="12">
                <div>
                    <table class="table-responsive">
                        <thead>
                            <tr>
                                <th @click="clickThead(index)" style="cursor:pointer" v-for="(item, index) in th" :key="index">
                                    <span v-if="item != 'Action'" style="float:left">{{item}}</span>
                                    <span v-if="item == 'Action'" style="float:right">{{item}}</span>
                                    <img v-if="item != 'Action'" :src="sortIcon[index]" width="16px" height="16px" style="float:right"/>
                                </th>
                            </tr>
                        </thead>
                        <tbody v-if="data.length == 0">
                            <tr>
                                <td class="text-center" colspan="5">
                                    {{errors}}
                                </td>
                            </tr>
                        </tbody>
                        <tbody v-else>
                            <tr @click="showDetail(id)" style="cursor:pointer" title="Lihat Detail" v-for="(body, id) in data" :key="id">
                                <td v-for="(item, index) in td" :key="index">
                                    <template v-if="item == 'tanggalMulai' || item == 'tanggalSelesai'">
                                        {{separatorDate(body[item])}}
                                    </template>
                                    <template v-else>
                                        <template v-if="item == 'status'">
                                            <template v-if="body[item] == '' || body[item] == 'null' || body[item] == null || body[item] == undefined || body[item] == 'W'">
                                                <div class="statusBaru status">
                                                    <span>Waiting</span>
                                                </div>
                                            </template>
                                            <template v-if="body[item] == 'A' || body[item] == 'a'">
                                                <div class="statusDisetujui status">
                                                    <span>Disetujui</span>
                                                </div>
                                            </template>
                                            <template v-if="body[item] == 'R' || body[item] == 'r'">
                                                <div class="statusDitolak status">
                                                    <span>Ditolak</span>
                                                </div>
                                            </template>
                                        </template>
                                        <template v-else>
                                            <template v-if="item == 'lamaCuti'">
                                                <span>{{body[item]}} Hari</span>
                                            </template>
                                            <template v-else>
                                                <span :title="body[item]">
                                                    {{body[item]}}
                                                </span>
                                            </template>
                                        </template>
                                    </template>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </CCol>
        </CRow>
    </div>
</div>
</template>

<script>
export default {
    props: ['data', 'th', 'td', 'styleTable', 'errors'],
    data() {
        return {
            sortIcon: [],
            modalDetail: false,
            closeIcon: require('../assets/menu/icon_close.svg'),
            details: ''
        }
    },
    mounted() {
        this.iconLoad('unsort', 'none')
    },
    watch: {
        modalDetail() {
            if(this.modalDetail == false) {
                this.details = ''
            }
        }
    },
    methods: {
        showDetail(id) {
            this.details = this.data[id]
            this.modalDetail = true
        },
        clickThead(index) {
            this.$emit('sort', index)
            this.iconLoad('sort', index)
        },
        loadStyle(index) {
            return 'width:' + this.styleTable[index] + ';' + 'max-width:' + this.styleTable[index]
        },
        iconLoad(type, index) {
            this.sortIcon = []
            let length = this.th.length
            var i = 0
            if (type == 'sort') {
                for(i=0;i<length;i++) {
                    let onPush = ''
                    if(index == i) {
                        onPush = require('../assets/menu/sort_normal.svg')
                    } else {
                        onPush = require('../assets/menu/sort_active.svg')
                    }
                    this.sortIcon.push(onPush)
                }
            } else {
                for(i=0;i<length;i++) {
                    let onPush = require('../assets/menu/sort_active.svg')
                    this.sortIcon.push(onPush)
                }
            }
        },
        separatorDate(data) {
            let tanggal = data.split("-")[2]
            let bulanTemp = data.split("-")[1]
            let tahun = data.split("-")[0]
            let bulan = ''
            if(bulanTemp == '01') {
                bulan = 'Jan'
            } else if(bulanTemp == '02') {
                bulan = 'Feb'
            } else if(bulanTemp == '03') {
                bulan = 'Mar'
            } else if(bulanTemp == '04') {
                bulan = 'Apr'
            } else if(bulanTemp == '05') {
                bulan = 'Mei'
            } else if(bulanTemp == '06') {
                bulan = 'Jun'
            } else if(bulanTemp == '07') {
                bulan = 'Jul'
            } else if(bulanTemp == '08') {
                bulan = 'Agu'
            } else if(bulanTemp == '09') {
                bulan = 'Sep'
            } else if(bulanTemp == '10') {
                bulan = 'Okt'
            } else if(bulanTemp == '11') {
                bulan = 'Nov'
            } else if(bulanTemp == '12') {
                bulan = 'Des'
            }
            return tanggal + ' ' + bulan + ' ' + tahun 
        },
    },
}
</script>

<style scoped>
@media only screen and (max-width:1278px) {
  .dekstop-view {
      display: none;
  }
}
@media only screen and (min-width:1279px) {
  .mobile-view {
      display: none;
  }
}
table {
    width: 100%;
}
table thead tr {
    background-color: rgba(244, 244, 244, 1);
}
thead th {
    padding-top: 16px;
    padding-left: 16px;
    padding-right: 16px;
    padding-bottom: 16px;
}
tbody td {
    padding-top: 8px;
    padding-bottom: 8px;
    padding-left: 16px;
    padding-right: 16px;
}
td,th {
    overflow-x: hidden !important;
    text-overflow: ellipsis;
    white-space: nowrap;
    border: 1px solid rgba(238, 238, 238, 1);
    font-size: 14px;
}
tr:nth-child(even) {
    background-color: rgba(252, 252, 252, 1);
}
tr:hover {
    background-color: whitesmoke;
}
div.sticky2 {
    position: -webkit-sticky;
    position: sticky;
    top: 105px;
    background-color: white;
    z-index: 1;
}
.content-sticky {
    background-color: white;
}
.status {
    width: 80px;
    height: 20px;
    color: white;
    border-radius: 4px;
    float: right;
    text-align: center;
}
.statusBaru {
    background-color: rgba(255, 209, 70, 1);
}
.statusDitolak {
    background-color: rgba(255, 0, 0, 1);
}
.statusDisetujui {
    background-color: rgba(94, 189, 116, 1);
}
::v-deep .modal-header {
    border-bottom: none !important;
}
.headers-modal {
    padding-top: 32px;
    padding-bottom: 32px;
    padding-left: 20px;
    padding-right: 20px;
    font-size: 18px;
    font-weight: bold;
    color: rgba(16, 16, 16, 1);
}
.btn-cancel {
    border-radius: 4px;
    width: 200px;
    float: left;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color:white;
    color: rgba(16, 16, 16, 1);
    font-weight: 500;
    font-size: 14px;
}
.btn-cancel:hover {
    border-radius: 4px;
    width: 200px;
    float: left;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color: rgba(48, 107, 221, 1);
    color: white;
}

</style>